import SimpleBar from 'simplebar-react'
import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const textColorLevel3 = 'var(--text-color-level3, rgba(26, 26, 26, 0.1))'
const primaryColorL1 = 'var(--primary-color, rgb(0, 105, 255))'
const fontWeightSemibold = 'var(--fontWeightSemibold, 600)'
import { Link } from '@calendly/ui/components/link'
import { OnetrustSettingsButton } from '@calendly/onetrust/redux'

import { useI18n } from 'locales'
import _Panel from "side_panel-Panel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/side_panel.js?styleId=Panel";
import _Container from "side_panel-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/side_panel.js?styleId=Container";
import _CookieSettingsButton from "side_panel-CookieSettingsButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/side_panel.js?styleId=CookieSettingsButton";
import _ScrollContainer from "side_panel-ScrollContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/side_panel.js?styleId=ScrollContainer";
import _InnerPaddingContainer from "side_panel-InnerPaddingContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/side_panel.js?styleId=InnerPaddingContainer";
import _StyledInline from "side_panel-StyledInline.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/side_panel.js?styleId=StyledInline";
import _StyledLink from "side_panel-StyledLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/side_panel.js?styleId=StyledLink";


const Panel = /*#__PURE__*/styled('div', null, {
  displayName: "Panel",
  styles: _Panel,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const CookieSettingsButton = /*#__PURE__*/styled(OnetrustSettingsButton, null, {
  displayName: "CookieSettingsButton",
  styles: _CookieSettingsButton
})

const ScrollContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ScrollContainer",
  styles: _ScrollContainer,
  attrs: props => ({
    ...props,
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const InnerPaddingContainer = /*#__PURE__*/styled('div', null, {
  displayName: "InnerPaddingContainer",
  styles: _InnerPaddingContainer,
  attrs: props => ({
    ...props,
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const StyledInline = /*#__PURE__*/styled('span', null, {
  displayName: "StyledInline",
  styles: _StyledInline
})

const StyledLink = /*#__PURE__*/styled(Link, null, {
  displayName: "StyledLink",
  styles: _StyledLink
})

const FooterLinks = () => {
  const { i18n } = useI18n()

  return (
    <StyledInline>
      <CookieSettingsButton />
      <StyledLink
        underline={false}
        href="https://calendly.com/legal/privacy-notice"
        target="_blank"
        rel="noopener noreferrer"
      >
        {`${i18n.t('booking.terms_and_conditions.privacy_policy')}`}
      </StyledLink>
    </StyledInline>
  )
}

const SidePanel = ({ children, ...props }) => (
  <Panel {...props} data-container="side-panel">
    <Container>
      <ScrollContainer as={SimpleBar} scrollableNodeProps={{ tabIndex: 0 }}>
        <InnerPaddingContainer>
          {children}
        </InnerPaddingContainer>
      </ScrollContainer>
      {useDeviceType('isDesktopUp') && (<FooterLinks />)}
    </Container>
  </Panel>
)

export default SidePanel
